import React, { useState, useEffect } from "react";
import "./statuses.scss";
import {
    useCreateTrnNumberMutation,
    useGetAdminMainQuery,
    useDeleteTrnNumberMutation,
    useUpdateTrnNumberMutation
} from "services/mainApi";

import { toast } from "react-toastify";

const TrnNumbers = () => {
    const [data, setData] = useState({ number: "" });
    const [editValues, setEditValues] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [trnToDelete, setTrnToDelete] = useState(null);

    const [createTrnNumber] = useCreateTrnNumberMutation();
    const {
        data: main,
        isLoading: loading,
        isError: error,
    } = useGetAdminMainQuery();

    const [deleteTrnNumber] = useDeleteTrnNumberMutation();
    const [updateTrnNumber] = useUpdateTrnNumberMutation();
    const [trnNumbersData, setTrnNumbersData] = useState("");

    useEffect(() => {
        setTrnNumbersData(main?.trn_numbers);
    }, [main]);

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        const result = await createTrnNumber({ data });

        if ("error" in result) {
            console.log("error");
        } else {
            toast.success("Successfully Created");
            setData({ number: "" });
        }
    };

    const handleDelete = async (id) => {
        const result = await deleteTrnNumber(id);

        if ("error" in result) {
            console.log("error");
        } else {
            toast.success("Successfully Deleted");
            setShowModal(false);
        }
    };

    const handleEditChange = (id, value) => {
        setEditValues({ ...editValues, [id]: value });
    };

    const handleUpdate = async (id) => {
        const number = editValues[id];

        if (!number) {
            toast.error("The TRN number hasn't been changed. Please update it before submitting.");
            return;
        }
        const result = await updateTrnNumber({ id, number });

        if ("error" in result) {
            console.log("error");
        } else {
            toast.success("Successfully Updated");
            setEditValues((prev) => {
                const copy = { ...prev };
                delete copy[id];
                return copy;
            });
        }
    };

    const confirmDelete = (id) => {
        setTrnToDelete(id);
        setShowModal(true);
    };

    const cancelDelete = () => {
        setShowModal(false)
        setTrnToDelete(null);
    };

    return (
        <div className="bg-white w-95 m-auto shadow p-5 mb-5 rounded">
            <div className="d-flex justify-content-between gap-1">
                <div className="w-60">
                    <h4>Create Transaction TRN Numbers</h4>
                    <hr className="w-80" />
                    <div className="d-flex gap-4">
                        <div className="form-group my-3 w-60">
                            <label className="fw-bold">TRN number</label>
                            <input
                                name="number"
                                className="form-control"
                                placeholder="Enter TRN number"
                                onChange={handleChange}
                                value={data.number}
                            />
                        </div>

                        <div className="form-group my-3 w-15">
                            <label className="fw-bold">&nbsp;</label>
                            <div>
                                <button onClick={handleSubmit} className="btn btn-primary w-100">
                                    Create
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-40">
                    <h4>Transaction TRN Numbers List</h4>
                    <hr />
                    <div className="trn-list">
                        {(trnNumbersData || []).map((el) => {
                            return (
                                <div className="d-flex gap-2 border-bottom py-2" key={el.id}>
                                    <div className="w-95 mx-1">
                                        <input
                                            name="number"
                                            className="form-control"
                                            placeholder="Enter TRN number"
                                            value={editValues[el.id] ?? el.number}
                                            onChange={(e) =>
                                                handleEditChange(el.id, e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="d-flex gap-4 justify-content-end align-items-center w-5">
                                        <i
                                            onClick={() => confirmDelete(el.id)}
                                            className="fa-solid fa-trash text-danger"
                                            type="button"
                                        ></i>
                                        <i
                                            onClick={() => handleUpdate(el.id)}
                                            className="fa-solid fa-check text-success"
                                            type="button"
                                        ></i>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Delete Modal */}
            {showModal && (
                <div className="modal p-5" style={{ display: "block" }}>
                    <div className="modal-dialog p-5">
                        <div className="modal-content p-5">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Deletion</h5>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to delete TRN: {trnNumbersData.find(trn => trn.id === trnToDelete)?.number} ?</p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={cancelDelete}>Cancel</button>
                                <button className="btn btn-danger" onClick={() => handleDelete(trnToDelete)}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TrnNumbers;
